import PageForm from "../../../components/pageForm/PageForm";
import HeaderQualification from "./components/header/header.qualification";
import BodyQualification from "./components/content/body.qualification";
import SubNavbar from "../../../components/SubNavbar/SubNavbar";
import { useState } from "react";
import MediaQuery from 'react-responsive';
import Button from "../../../components/button";
import { Filter, SearchLoop } from "../../../assets/icons";
import BottomSheet from "../../../components/bottomSheet/BottomSheet";
import StyledInput from "../../../components/styledInput/StyledInput";

// Options de recherche (constante partagée)
export const QUALIFICATION_SEARCH_OPTIONS = [
    { value: '', label: 'Tous' },
    { value: 'idBestt', label: 'ID BeSTT' },
    { value: 'name', label: 'Titre' },
    { value: 'codePCS', label: 'PCS' },
    { value: 'codeROME', label: 'ROME' },
];

const Qualification = () => {
    const [search, setSearch] = useState('');
    const [optionSearch, setOptionSearch] = useState('');
    // false = n'affiche pas les désactivé (par défaut), true = affiche seulement désactivé, null = affiche tout
    const [showDisabled, setShowDisabled] = useState(false);
    
    // États pour le BottomSheet de filtre mobile
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [tempSearch, setTempSearch] = useState('');
    const [tempOptionSearch, setTempOptionSearch] = useState('');
    const [tempShowDisabled, setTempShowDisabled] = useState(false);
    
    // Ouvrir le BottomSheet et initialiser les valeurs temporaires
    const openFilterSheet = () => {
        setTempSearch(search);
        setTempOptionSearch(optionSearch);
        setTempShowDisabled(showDisabled);
        setIsFilterOpen(true);
    };
    
    // Appliquer les filtres
    const applyFilters = () => {
        setSearch(tempSearch);
        setOptionSearch(tempOptionSearch);
        setShowDisabled(tempShowDisabled);
        setIsFilterOpen(false);
    };

    return (
        <>
            <PageForm>
                <>
                    <SubNavbar>
                        <div className="flex justify-between items-center w-full gap-3">
                            {/* Desktop: Search controls */}
                            <MediaQuery minWidth={768}>
                                <HeaderQualification 
                                    search={search} 
                                    setSearch={setSearch} 
                                    optionSearch={optionSearch} 
                                    setOptionSearch={setOptionSearch}
                                    showDisabled={showDisabled}
                                    setShowDisabled={setShowDisabled}
                                />
                            </MediaQuery>
                            
                            {/* Mobile: Filter button + Add button */}
                            <MediaQuery maxWidth={767}>
                                <Button
                                    color={'SECONDARY'}
                                    size={'SM'}
                                    onClick={openFilterSheet}
                                >
                                    <Filter wh={16} color="#374151" />
                                    <span>Filtrer</span>
                                </Button>
                                <HeaderQualification 
                                    search={search} 
                                    setSearch={setSearch} 
                                    optionSearch={optionSearch} 
                                    setOptionSearch={setOptionSearch}
                                    showDisabled={showDisabled}
                                    setShowDisabled={setShowDisabled}
                                    mobileOnly={true}
                                />
                            </MediaQuery>
                        </div>
                    </SubNavbar>
                    <BodyQualification search={search} optionSearch={optionSearch} showDisabled={showDisabled}/>
                    
                    {/* Bottom Sheet Filtre pour mobile */}
                    <BottomSheet
                        isOpen={isFilterOpen}
                        onClose={() => setIsFilterOpen(false)}
                        title="Filtrer"
                    >
                        <div className="flex flex-col gap-4">
                            {/* Recherche */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Rechercher
                                </label>
                                <StyledInput
                                    type={'text'}
                                    placeholder={'Rechercher...'}
                                    imgFront={<SearchLoop wh={16} color={'#6B7280'} />}
                                    value={tempSearch}
                                    onChange={(e) => setTempSearch(e.target.value)}
                                />
                            </div>

                            {/* Type de recherche */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Rechercher par
                                </label>
                                <select
                                    className="w-full h-10 pl-3 pr-8 ft-b placeholder-gray-600 border rounded-lg text-sm focus:border-yellow-500 focus:outline-none"
                                    onChange={(e) => setTempOptionSearch(e.target.value)}
                                    value={tempOptionSearch}
                                >
                                    {QUALIFICATION_SEARCH_OPTIONS.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Filtre désactivé */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Afficher les qualifications désactivé
                                </label>
                                <select
                                    className="w-full h-10 pl-3 pr-8 ft-b placeholder-gray-600 border rounded-lg text-sm focus:border-yellow-500 focus:outline-none"
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        setTempShowDisabled(val === 'null' ? null : val === 'true');
                                    }}
                                    value={tempShowDisabled === null ? 'null' : String(tempShowDisabled)}
                                >
                                    <option value="false">Non (actives uniquement)</option>
                                    <option value="true">Oui (désactivé uniquement)</option>
                                    <option value="null">Toutes</option>
                                </select>
                            </div>

                            {/* Bouton Appliquer */}
                            <Button
                                color="PRIMARY"
                                size="FULL"
                                onClick={applyFilters}
                                className="w-full mt-2"
                            >
                                Appliquer
                            </Button>
                        </div>
                    </BottomSheet>
                </>
            </PageForm>
        </>
    );
};

export default Qualification;
